import { useContext, useEffect } from 'react';
import get from 'lodash/get';
import startsWith from 'lodash/startsWith';
import find from 'lodash/find';
import { useSelector } from 'react-redux';
import { AppContext } from 'context';
import { useAction, useProgressSuccess } from 'hooks';
import history from 'helpers/history';
import Hcp from 'modules/Hcp';
import Account from 'modules/Account';
import ClinicManagement from 'modules/ClinicManagement';
import { getPatientValues } from './helpers';
export const useInitialEffects = (patientId)=>{
    const { getUrl } = useContext(AppContext);
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const isConnectToClinicInProgress = useSelector(Account.selectors.isConnectToClinicInProgress);
    const isFetchPatientsInProgress = useSelector(Hcp.selectors.isFetchPatientsInProgress);
    const enrollingSharingRequests = useSelector(Hcp.selectors.enrollingSharingRequests);
    const patients = useSelector(Hcp.selectors.patients);
    const startSyncQueue = useAction(Hcp.actions.startSyncQueue);
    const onEnrollPatient = useAction(Hcp.actions.enrollPatient);
    const onActivatePatient = useAction(Hcp.actions.activatePatient);
    const onDeactivatePatient = useAction(Hcp.actions.deactivatePatient);
    const onFetchClinicSettings = useAction(ClinicManagement.actions.fetchClinicSettings);
    const stopSyncQueue = useAction(Hcp.actions.stopSyncQueue);
    const err404url = getUrl('error', {
        code: 404
    });
    const onPatientActivate = ()=>{
        const profilesReferenceKey = get(activeClinicMembership, 'clinic.profilesReferenceKey');
        if (!profilesReferenceKey || isConnectToClinicInProgress || isFetchPatientsInProgress) {
            return;
        }
        if (startsWith(patientId, 'esr-')) {
            const sharingRequestId = +patientId.substring(4);
            const shareRequest = find(enrollingSharingRequests, {
                sharingRequestId
            });
            if (!shareRequest) {
                history.replace(err404url);
                return;
            }
            const patientValues = getPatientValues(shareRequest);
            onEnrollPatient(patientValues, shareRequest, activeClinicMembership);
            return;
        }
        const patient = find(patients, {
            id: patientId
        });
        if (!patient) {
            history.replace(err404url);
            return;
        }
        if (patient.encryptedPhiSetReferenceKey) {
            onActivatePatient(patient, activeClinicMembership);
        }
    };
    useProgressSuccess(isFetchPatientsInProgress, false, onPatientActivate);
    useEffect(()=>{
        startSyncQueue();
        onPatientActivate();
        if (activeClinicMembership) {
            onFetchClinicSettings(activeClinicMembership.clinicId);
        }
        return ()=>{
            stopSyncQueue();
            onDeactivatePatient();
        };
    }, [
        patientId
    ]);
    return null;
};
